import StatusCard from "./StatusCard"
import {useState,useLayoutEffect} from 'react'
import axios from 'axios'
import {BACKEND_URL} from '../config/config'
import cookie from 'cookie'
import ReactAudioPlayer from 'react-audio-player';

const useWindowSize = ()=>{
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }
const styleTextarea={
    outline:0,
    resize:"none",
    width:"100%",
    height:"150px",
    padding:"15px",
    borderRadius:"10px",
    backgroundColor:"#F7F7F7",
    border:"none",
    boxShadow: "inset 2px 2px 2px 0px #dddddd",
    fontSize:"16px"



}
var Lesson = (props) => {
    const [width, height] = useWindowSize();
    var videoWidth=(width>800)?800:(width-50);
    var videoHeight=videoWidth*390/640;
    var videocode=props.video&&props.video[0]?props.video[0].code:""
    var audiocode=props.audiocode;
    var [homework,setHomework]=useState("")
    var [loading,setLoading]=useState(false)
    var [homeworks,setHomeworks]=useState(props.homework||[])
    var [error,setError]=useState("")
    console.log(props)
    var info="";
    var sendHomework=async ()=>{
        if (homework.length>0){
            var token = ""
            var cook=cookie.parse(document.cookie)
            if (cook&&cook.ptq) token=cook.ptq;
            if (token)
            {
                setLoading(true)
                axios.get(BACKEND_URL+'/complete',{params:{
                    token,homework,complete:true,lesson:props.uri
                }}).then(d=>d.data).then(d=>{
                    setHomeworks([...homeworks,[homework]])
                    setLoading(false)
                }).catch(e=>{
                    console.log(e)
                    setLoading(false)
                })
                setHomework('')
            }
           
        }
    }
    
   
    return (
    <div>
         <StatusCard {...props} {...{heading:'#'+props.index+'. '+props.heading}}>
        {(props.status=='opened'||props.status=='done')&&(<div>
            {props.full&&(<iframe width={videoWidth} height={videoHeight} src={"https://play.boomstream.com/"+videocode} frameborder="0" scrolling="no" allowFullScreen></iframe>)}
            {(props.full&&audiocode)&&(<div><br/><b>Аудио-практика к занятию</b><br/><br/><ReactAudioPlayer
                controls
            >
                <source src={"https://hb.bizmrg.com"+audiocode+".webm"} type="audio/webm"/>
                <source src={"https://hb.bizmrg.com"+audiocode+".mp3"} type="audio/mpeg"/>
                
                
                </ReactAudioPlayer><br/><a download href={"https://hb.bizmrg.com"+audiocode+".mp3"}>скачать аудио</a><br/><br/></div>)}
        <div>
         {props.full&&props.questions&&props.questions.map(
             question=>(<div style={{width:'800px',maxWidth:"92%"}}>
                 <b>Домашнее задание</b><br/>
                 <div  style={{padding:'10px 0px'}}>
                    <div>{question.heading}</div>
                    <div>{question.description}</div>
                </div>
                <div>
                    
                    {homeworks&&homeworks.map(message=>(<div>{"Отправлено: "+message}</div>))}
                    <textarea style={styleTextarea} onChange={(e)=>setHomework(e.target.value)} value={homework}></textarea>
                    <div style={{paddingTop:"10px"}}><span className={!loading&&homeworks.length==0?"btn btn-accent":"btn"} onClick={()=>sendHomework()}>{loading?"Подождите...":"Отправить"}</span><span className="info">{info}</span></div>
                </div>
                
             </div>))}
             {props.full&&(<div style={{paddingTop:"20px",cursor:"pointer"}}>
                 {props.next&&(homeworks.length>0?(<a href={props.next}><span className="btn btn-accent">Перейти к следующему уроку >></span></a>):(<div>Следующий урок будет доступен после отправки задания</div>))}
                 </div>)}
             

             <style>{`
                    .info {
                        padding-top: 7px;
                        padding-left: 7px;
                        padding-bottom:5px;
                        padding-right:7px;
                    }   
                    .btn {
                        padding-top: 7px;
                        padding-left: 7px;
                        padding-bottom:5px;
                        padding-right:7px;
                        cursor: pointer;
                        opacity: .8;
                        background-color:#CFCFCF;
                        margin:10px;
                        border-radius:7px;
                    }
                    .btn-accent{
                        background-color:#98CFA7;
                    }
                    .btn:hover {
                        opacity:1;
                    }
                `}</style>
            </div>
        </div>)}
        {props.full&&props.status=='wait'&&(<div>Урок еще не доступен</div>)}
        {props.full&&props.status=='locked'&&(<div>Доступ к уроку закрыт. Обратитесь <a href={"https://vk.me/sevapremcom"}><b>по этой ссылке</b></a> чтобы приобрести доступ</div>)}

        
        </StatusCard>
    </div>
    )
}
export default Lesson